module.exports = __webpack_public_path__ + "img/w3_trash_solid_delete_white.0ecfd854.png";